import { Cell } from '@/components/Bicester/Table/Cells/index';
import _ from 'lodash';
import React, { useState, useEffect, useRef } from 'react';
import { Popover, Whisper } from 'rsuite5';
import { TypeAttributes } from 'rsuite5/esm/@types/common';
import { OverlayTriggerType } from 'rsuite5/esm/Overlay/OverlayTrigger';

export interface WithPopoverCellProps {
  rowData?: BaseObject<any>;
  dataKey: string;
  popoverContent?: React.ReactNode;
  trigger?: OverlayTriggerType | OverlayTriggerType[];
  placement?: TypeAttributes.Placement;
}

const WithPopoverCell = ({
  rowData,
  dataKey,
  popoverContent = _.get(rowData, dataKey),
  trigger = 'hover',
  placement = 'top',
  ...props
}: WithPopoverCellProps) => {
  const cellRef = useRef(null);
  const [isEllipsis, setIsEllipsis] = useState(false);

  const cellData = _.get(rowData, dataKey);

  useEffect(() => {
    setIsEllipsis(cellRef.current?.clientWidth < cellRef.current?.scrollWidth);
  }, [cellRef.current?.clientWidth]);

  return (
    <Whisper
      trigger={isEllipsis ? trigger : 'none'}
      placement={placement}
      speaker={<Popover>{cellData}</Popover>}
    >
      <Cell {...props}>
        <div
          className="text-[14px] overflow-hidden overflow-ellipsis whitespace-nowrap"
          ref={cellRef}
        >
          <span>{cellData}</span>
        </div>
      </Cell>
    </Whisper>
  );
};

export default WithPopoverCell;
